import * as BcmClient from '@/services/Bcm'

export const fetchBlueprintTasks = ({ commit }, data) => {
  return BcmClient.getBlueprintTasks(data)
}

export const fetchTaskEvidence = ({ commit }, data) => {
  return BcmClient.getTaskEvidence(data)
}

export const createTaskEvidence = ({ commit }, data) => {
  return BcmClient.postTaskEvidence(data)
}

export const updateTaskEvidence = ({ commit }, data) => {
  return BcmClient.putTaskEvidence(data)
}

export const fetchQMatrices = ({ commit }, data) => {
  return BcmClient.getBlueprintQMatrices(data)
}

export const createQMatrix = ({ commit }, data) => {
  return BcmClient.postQMatrix(data)
}

export const updateQMatrix = ({ commit }, data) => {
  return BcmClient.putQMatrix(data)
}

export const createBlueprintTask = ({ commit }, data) => {
  return BcmClient.postBlueprintTask(data)
}

export const updateBlueprintTask = ({ commit }, data) => {
  return BcmClient.putBlueprintTask(data)
}

export const fetchTaskItems = ({ commit }, data) => {
  return BcmClient.getTaskItems(data)
}

export const createTaskItem = ({ commit }, data) => {
  return BcmClient.postTaskItem(data)
}

export const updateTaskItem = ({ commit }, data) => {
  return BcmClient.putTaskItem(data)
}

export const fetchConstructs = ({ commit }, data) => {
  return BcmClient.getConstructs(data)
}

export const fetchConstructTypes = ({ commit }, data) => {
  return BcmClient.getConstructTypes(data)
}

export const createConstruct = ({ commit }, data) => {
  return BcmClient.postConstruct(data)
}

export const updateConstruct = ({ commit }, data) => {
  return BcmClient.putConstruct(data)
}

export const fetchModels = ({ commit }, data) => {
  return BcmClient.getModels(data)
}

export const updateModel = ({ commit }, data) => {
  return BcmClient.putModel(data)
}

export const createModel = ({ commit }, data) => {
  return BcmClient.postModel(data)
}

export const createModelItemMappings = ({ commit }, data) => {
  return BcmClient.postModelItemMappings(data)
}

export const removeModelItemMappings = ({ commit }, data) => {
  return BcmClient.deleteModelItemMappings(data)
}

export const createQMatrixItemMapping = ({ commit }, data) => {
  return BcmClient.postQMatrixItemMappings(data)
}

export const fetchAssociationTypes = ({ commit }, data) => {
  return BcmClient.getAssociationTypes(data)
}

export const createConstructTaskItemMapping = ({ commit }, data) => {
  return BcmClient.postConstructTaskItemMapping(data)
}

export const updateConstructTaskItemMapping = ({ commit }, data) => {
  return BcmClient.putConstructTaskItemMapping(data)
}

export const deleteConstructTaskItemMapping = ({ commit }, data) => {
  return BcmClient.deleteConstructTaskItemMapping(data)
}

export const deleteModel = ({ commit }, data) => {
  return BcmClient.deletePsychometricModel(data)
}

export const removeQMatrixItemMapping = ({ commit }, data) => {
  return BcmClient.deleteQMatrixItemMapping(data)
}

export const deleteQMatrix = ({ commit }, data) => {
  return BcmClient.deleteQMatrices(data)
}

export const deleteConstruct = ({ commit }, data) => {
  return BcmClient.deleteConstruct(data)
}

export const deleteTaskEvidence = ({ commit }, data) => {
  return BcmClient.deleteTaskEvidence(data)
}

export const deleteTaskItems = ({ commit }, data) => {
  return BcmClient.deleteTaskItems(data)
}

export const deleteTask = ({ commit }, data) => {
  return BcmClient.deleteTask(data)
}

export default {
  fetchBlueprintTasks,
  fetchTaskEvidence,
  fetchQMatrices,
  createQMatrix,
  updateQMatrix,
  createBlueprintTask,
  updateBlueprintTask,
  createTaskEvidence,
  updateTaskEvidence,
  fetchTaskItems,
  updateTaskItem,
  createTaskItem,
  fetchConstructs,
  fetchConstructTypes,
  createConstruct,
  updateConstruct,
  fetchModels,
  updateModel,
  createModel,
  createModelItemMappings,
  createQMatrixItemMapping,
  fetchAssociationTypes,
  createConstructTaskItemMapping,
  removeModelItemMappings,
  deleteModel,
  removeQMatrixItemMapping,
  deleteQMatrix,
  updateConstructTaskItemMapping,
  deleteConstructTaskItemMapping,
  deleteConstruct,
  deleteTaskEvidence,
  deleteTaskItems,
  deleteTask
}
